
<script setup>
  import { ref, computed, onBeforeMount } from "vue";
  import { useCompanyStore } from "@/stores/company";
  import { useUiStore } from "@/stores/ui";
  import { useDevicesStore } from "@/stores/devices";
  const emit = defineEmits(['refresh']);
  const uiStore = useUiStore();
  const devicesStore = useDevicesStore();

  // const global_user_name = inject(['global_user_name']);
  const user = ref(JSON.parse(localStorage.getItem("userDetails")));
  let isSubmitted = ref(false);
  let name = ref(null);
  let mac_address = ref(null);
  let app = ref(null);
  let appsOptions = ref([]);
  let isLoading = ref(true);

  const company_id = useCompanyStore().companyId;
  const getModalInfo = computed(() => uiStore.modalData);
  const getModalAction = computed(() => uiStore.modalAction);

  const onSubmit = () => {
    isSubmitted.value = true;
    // let packagesArr = [];

    // apps.value.map((app) => {
    //   packagesArr.push(app.packageId)
    // });
    
    let data = { 
      entityId: company_id,
      kioskName : name.value,
      macAddress : mac_address.value,
      userName : user.value.first_name+' '+ user.value.last_name,
      userId : user.value.user_id,
      connectionType : 'daemon',
      packages : [app.value.packageId],
    }

    devicesStore.restartApp(data)
    .then(() => {
      resetStoreData();
      emit('refresh');
    })
    .catch(() => {
      isSubmitted.value = false;
    });
  };

  const resetStoreData = () =>{
    uiStore.resetModalStore();
  };

  onBeforeMount(()=>{
    if(getModalInfo.value && getModalInfo.value.data_type == 'device' && getModalAction.value == 'restart_app'){
      name.value = getModalInfo.value.name;
      mac_address.value = getModalInfo.value.mac_address;

      let data = { 
        entityId: company_id,
        kioskName : getModalInfo.value.name,
        macAddress : getModalInfo.value.mac_address,
        userName : user.value.first_name+' '+ user.value.last_name,
        userId : user.value.user_id,
        connectionType : 'daemon',
      }

      devicesStore.fetchInstalledAppsGrid(data)
      .then((res) => {
        appsOptions.value = JSON.parse(res.data);
        isLoading.value = false;
      })
      .catch(()=> {
      });
    }
  });
</script>

<template>
  <DModal v-if="getModalAction === 'restart_app'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Restart App </template>

    <template #body>
      <div class="delete-text mb-3">
        <span>Select the application you want to <b>"Restart"</b> on the device "{{ name }}" ?</span>
      </div>

      <div class="relative">
        <span v-if="app" class="multiselect-title-span" >Application</span>
        <VMultiselect v-model="app" :options="appsOptions" trackBy="packageId" label="name" :disabled="!appsOptions.length" :loading="isLoading" 
          :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Application"
        />
      </div>

    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button :disabled="!app || isSubmitted "  
          @click="onSubmit" type="button" class="btn btn-primary add-button mr-30">
            Restart <span v-if="isSubmitted"  class="spinner-sm" role="status" aria-hidden="true" ></span>
          </button>
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button">Cancel</button>
        </div>
      </div>
    </template>

  </DModal>
</template>
